'use client';

import { Switch as SwitchPrimitive } from '@base-ui/react/switch';
import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';

const switchVariants = cva(
  'inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background data-disabled:cursor-not-allowed data-disabled:opacity-50 data-checked:bg-primary data-unchecked:bg-input',
  {
    variants: {
      size: {
        sm: 'h-4 w-7 [&>[data-slot=switch-thumb]]:size-3 [&>[data-slot=switch-thumb]]:data-checked:translate-x-3',
        default: 'h-5 w-9 [&>[data-slot=switch-thumb]]:size-4 [&>[data-slot=switch-thumb]]:data-checked:translate-x-4',
        lg: 'h-6 w-11 [&>[data-slot=switch-thumb]]:size-5 [&>[data-slot=switch-thumb]]:data-checked:translate-x-5',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

type SwitchProps = SwitchPrimitive.Root.Props &
  VariantProps<typeof switchVariants> & {
    className?: string;
  };

function Switch({ className, size = 'default', ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root data-slot="switch" className={cn(switchVariants({ size, className }))} {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform data-unchecked:translate-x-0"
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch, switchVariants };
